import { FC, Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';
// import Components
import { Button, Modal, Title } from '@geneui/components';
import ExpandableContent from './ExpandableContent';
import ExpandableKeyValue from 'components/common/ExpandableKeyValue';
// Import Constants
import { l } from 'constants/common';
// Import Types
import { CommunicationCategoryData } from './types';
// Import Styles
import styles from './communicationCountItem.module.scss';

interface Props {
    onClose: () => void;
    convertedStats: CommunicationCategoryData[];
}

const CommunicationCountInfoModal: FC<Props> = ({ onClose, convertedStats }) => {
    const { t } = useTranslation();

    return (
        <Modal
            size="content-size"
            visible={true}
            withPortal={true}
            closeOnClickOutside={true}
            closable={false}
            title={t(l.CommunicationInfo)}
            onCancel={onClose}
            footer={<Button onClick={onClose}>{t(l.Close)}</Button>}
        >
            <div className={styles.container}>
                {convertedStats.map(({ title, values }) => (
                    <Fragment key={title}>
                        <Title text={t(l[title])} color="base" withLine={true} className={styles.title} />
                        {values.map(({ status, count, values }) => (
                            <ExpandableKeyValue key={status} label={t(l[status])} value={count} isExpandable={!!values}>
                                <ExpandableContent content={values} />
                            </ExpandableKeyValue>
                        ))}
                    </Fragment>
                ))}
            </div>
        </Modal>
    );
};

export default memo(CommunicationCountInfoModal);
